import { RootState } from 'types';

export const userData = (state: RootState) => state.login;
